import { Detail, Template } from "@gravity-ui/illustrations";
import { Text } from "@gravity-ui/uikit";
import { AnimatePresence, motion } from "framer-motion";

import css from "../../SliderCard.module.scss";
import { iconAnimation, titleAnimation } from "./SlideExporter.constants";

export const SlideExporter = ({ activeIndex }: { activeIndex: number }) => {
  return (
    <>
      <AnimatePresence initial={true} mode="wait">
        <motion.div {...titleAnimation} key={"title.slide." + activeIndex}>
          <Text variant="subheader-2">Выгрузки</Text>
        </motion.div>
      </AnimatePresence>

      <div className={css.slideBalanceContainer}>
        <motion.div
          style={{ position: "absolute", x: -90, y: 90 }}
          {...iconAnimation}
          transition={{ delay: 0.2, type: "spring" }}
          key={"coin." + activeIndex}
        >
          <Detail fontSize={10} />
        </motion.div>
        <motion.div
          style={{ position: "absolute", x: 75, y: 40 }}
          {...iconAnimation}
          transition={{ delay: 0.6, type: "spring" }}
          key={"lock." + activeIndex}
        >
          <Template />
        </motion.div>
      </div>
    </>
  );
};
